import { AvailabilityGroupClientDto, AvailabilityPriceDto } from 'service-api/src/types/api'
import { isEmpty } from './common'

export const petRequiresTemperTest = (availabilityGroup: AvailabilityGroupClientDto | undefined) => {
  const { available, condition, unavailableReason, affectedByPets } = availabilityGroup?.availabilities?.[0] || {}
  return Boolean(available && condition?.reason?.type === 'TEMPER_TEST' && !unavailableReason && affectedByPets?.length)
}

export const petFailedTemperTest = (availabilityGroup: AvailabilityGroupClientDto | undefined) => {
  const { available, condition, unavailableReason, affectedByPets } = availabilityGroup?.availabilities?.[0] || {}
  return Boolean(
    !available &&
      !condition?.reason &&
      unavailableReason?.type === 'TEMPER_TEST' &&
      unavailableReason.contingent &&
      affectedByPets?.length
  )
}

export const petPassedTemperTest = (availabilityGroup: AvailabilityGroupClientDto | undefined) => {
  const { available, condition, unavailableReason, affectedByPets } = availabilityGroup?.availabilities?.[0] || {}
  return Boolean(available && !condition?.reason && !unavailableReason && !affectedByPets?.length)
}

export const petHasTemperTestScheduled = (availabilityGroup: AvailabilityGroupClientDto | undefined) => {
  const { available, condition, unavailableReason, affectedByPets } = availabilityGroup?.availabilities?.[0] || {}
  return Boolean(
    available &&
      condition?.reason?.type === 'TEMPER_TEST' &&
      condition.dependOnDate &&
      !unavailableReason &&
      affectedByPets?.length
  )
}

export const petCannotBookOnline = (availabilityGroup: AvailabilityGroupClientDto | undefined) => {
  const { available, condition, unavailableReason, affectedByPets } = availabilityGroup?.availabilities?.[0] || {}
  return Boolean(
    !available &&
      !condition?.reason &&
      unavailableReason?.type === 'SALES_CHANNEL' &&
      unavailableReason.text?.toLowerCase() === 'client' &&
      affectedByPets?.length
  )
}

export const allNonTestedPetsCannotBookOnline = (availabilityGroup: AvailabilityGroupClientDto | undefined) => {
  const { available, condition, unavailableReason, affectedByPets } = availabilityGroup?.availabilities?.[0] || {}
  return Boolean(
    !available &&
      !condition?.reason &&
      unavailableReason?.type === 'TEMPER_TEST' &&
      !unavailableReason.contingent &&
      affectedByPets?.length
  )
}

export const tooSoonToBook = (availabilityGroup: AvailabilityGroupClientDto | undefined) => {
  const { available, condition, unavailableReason, affectedByPets } = availabilityGroup?.availabilities?.[0] || {}
  return Boolean(
    !available &&
      condition?.reason?.type === 'TEMPER_TEST' &&
      unavailableReason?.type === 'TEMPER_TEST' &&
      affectedByPets?.length
  )
}

export const getFilteredDiscountBenefits = (discounts: AvailabilityPriceDto['discounts']) => {
  const discountBenefits = (discounts || []).flatMap((discount) =>
    (discount.benefits || []).map((benefit) => ({
      value: benefit.amount,
      type: benefit.priceType,
    }))
  )
  return discountBenefits.filter((discount) => !isEmpty(discount.value))
}

export const affectedPetIds = (availabilityGroups: AvailabilityGroupClientDto[] | AvailabilityGroupClientDto[][]) =>
  availabilityGroups.flat().reduce((ids, group) => {
    group.availabilities?.forEach((availability) => {
      availability.affectedByPets?.forEach((pet) => {
        if (pet.locationPetProfileId && !ids.includes(pet.locationPetProfileId)) {
          ids.push(pet.locationPetProfileId)
        }
      })
    })
    return ids
  }, [] as string[])
